import { gql } from "@apollo/client";

export const AVAILABLE_TIMES = gql`
  query availableTimesV2($data: AvailableTimesInputV2!) {
    availableTimesV2(
      data: $data
    ) {
      daysMonth {
        date,
        day,
        month,
        year,
        available,
        isNearestAvailableDay,
      },
      appointmentCreateType,
      availableTimes {
        date,
        times {
          time,
          resourcesId,
        },
        appointmentTypes {
          appointmentType,
          petId,
        }
      },
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        background,
      },
      timeZone,
      success,
      messages
    }
  }
`;
